import { useQuery } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import { FactDetails } from '@/api/types/backend-dto-types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export function useGetFactDetailsBatch(
  matterId: string | null | undefined,
  subsetId: string | undefined,
  factIds: string[],
) {
  const { getFetchConfig } = useGetFetchConfig();

  return useQuery<FactDetails[], Error>(
    [QueryEntity.FactDetails, { factIds, subsetId }],
    async () => {
      const res = await fetch(
        `${APIBaseChronos}/api/matters/${matterId}/subset/${subsetId}/facts/batch`,
        getFetchConfig({ method: FetchMethod.POST, data: { factIds } }),
      );
      if (!res.ok) throw new Error('Failed to fetch facts');
      return res.json();
    },
    {
      refetchOnWindowFocus: false,
      enabled: !!matterId && !!subsetId && factIds.length > 0,
      keepPreviousData: true,
    },
  );
}
